export const NotificationTypeLabel = {
  0: 'Stock mínimo',
  1: 'Artículos retirados de bodega',
  2: 'Artículos faltantes',
  3: 'Mensaje',
  4: 'Comentario de aplicante',
}
